// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bucket-navbar {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background-color: rgba(30, 30, 30, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  padding: 0 15px;
  gap: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  z-index: 90;
  scrollbar-width: none;
  -ms-overflow-style: none;
  transition: background-color 0.5s ease;
}

.bucket-navbar.timer-active {
  background-color: #003300; /* Even darker green */
}

.bucket-navbar::-webkit-scrollbar {
  display: none;
}

.bucket-nav-button {
  min-width: 100px;
  height: 35px;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: white;
  padding: 8px 12px;
  font-family: inherit;
  outline: none;
  box-shadow: none;
  transform: scale(1);
  flex-shrink: 0;
}

.bucket-nav-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.bucket-nav-button--selected {
  background-color: rgba(0, 123, 255, 0.6);
  border: 2px solid rgba(0, 123, 255, 0.8);
  box-shadow: 0 0 12px rgba(0, 123, 255, 0.4);
  transform: scale(1.05);
}

.bucket-nav-button__title {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.bucket-nav-button--highlight {
  background-color: rgba(0, 123, 255, 0.6);
  border: 2px solid rgba(0, 123, 255, 0.8);
  box-shadow: 0 0 12px rgba(0, 123, 255, 0.4);
  transform: scale(1.05);
  transition: all 0.3s ease;
}

.bucket-nav-button--hidden {
  opacity: 0.4;
  background-color: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  position: relative;
}

.bucket-nav-button--hidden::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 8px;
  right: 8px;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.6);
  transform: translateY(-50%);
}

.bucket-nav-button--hidden:hover {
  opacity: 0.6;
  background-color: rgba(255, 255, 255, 0.08);
}

/* === Reorder-Modus (Shift gedrueckt) === */

.bucket-nav-button--reorder {
  cursor: grab;
  border-style: dashed;
  border-color: rgba(74, 158, 255, 0.4);
}

.bucket-nav-button--reorder:active {
  cursor: grabbing;
}

.bucket-nav-button--dragging {
  opacity: 0.4;
  cursor: grabbing;
}

.bucket-nav-button--drag-over {
  border-color: #4a9eff !important;
  border-style: solid !important;
  box-shadow: 0 0 12px rgba(74, 158, 255, 0.5);
  transform: scale(1.05);
}

/* Additional mobile-specific styles */
@media (max-width: 768px) {
  .bucket-navbar {
    /* Ensure smooth scrolling on mobile */
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    width: 100vw !important;
    max-width: 100vw !important;
    box-sizing: border-box !important;
    position: fixed !important;
    top: 60px !important;
    z-index: 99 !important;
  }

  .bucket-nav-button {
    /* Better touch targets for mobile */
    position: relative;
    overflow: hidden;
  }

  .bucket-nav-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    transition: background-color 0.2s ease;
  }

  .bucket-nav-button:active::before {
    background-color: rgba(255, 255, 255, 0.1);
  }

  .bucket-nav-button__title {
    /* Ensure text remains readable on mobile */
    position: relative;
    z-index: 1;
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  }

  /* Smooth transition for highlights on mobile */
  .bucket-nav-button--highlight {
    animation: mobileHighlight 0.3s ease-in-out;
  }

  @keyframes mobileHighlight {
    0% {
      transform: scale(1);
      box-shadow: 0 0 0 rgba(0, 123, 255, 0);
    }
    50% {
      transform: scale(1.15);
      box-shadow: 0 0 20px rgba(0, 123, 255, 0.8);
    }
    100% {
      transform: scale(1.1);
      box-shadow: 0 0 15px rgba(0, 123, 255, 0.6);
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/components/BucketNavbar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,wCAAwC;EACxC,2BAA2B;EAC3B,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB,EAAE,sBAAsB;AACnD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,2CAA2C;EAC3C,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,2CAA2C;EAC3C,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA,4CAA4C;;AAE5C;EACE,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE;IACE,sCAAsC;IACtC,uBAAuB;IACvB,iCAAiC;IACjC,uBAAuB;IACvB,2BAA2B;IAC3B,iCAAiC;IACjC,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,2CAA2C;IAC3C,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,yCAAyC;EAC3C;;EAEA,+CAA+C;EAC/C;IACE,2CAA2C;EAC7C;;EAEA;IACE;MACE,mBAAmB;MACnB,sCAAsC;IACxC;IACA;MACE,sBAAsB;MACtB,2CAA2C;IAC7C;IACA;MACE,qBAAqB;MACrB,2CAA2C;IAC7C;EACF;AACF","sourcesContent":[".bucket-navbar {\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 50px;\n  background-color: rgba(30, 30, 30, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  padding: 0 15px;\n  gap: 10px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  z-index: 90;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  transition: background-color 0.5s ease;\n}\n\n.bucket-navbar.timer-active {\n  background-color: #003300; /* Even darker green */\n}\n\n.bucket-navbar::-webkit-scrollbar {\n  display: none;\n}\n\n.bucket-nav-button {\n  min-width: 100px;\n  height: 35px;\n  background-color: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 6px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: white;\n  padding: 8px 12px;\n  font-family: inherit;\n  outline: none;\n  box-shadow: none;\n  transform: scale(1);\n  flex-shrink: 0;\n}\n\n.bucket-nav-button:hover {\n  background-color: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.bucket-nav-button--selected {\n  background-color: rgba(0, 123, 255, 0.6);\n  border: 2px solid rgba(0, 123, 255, 0.8);\n  box-shadow: 0 0 12px rgba(0, 123, 255, 0.4);\n  transform: scale(1.05);\n}\n\n.bucket-nav-button__title {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.2;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.bucket-nav-button--highlight {\n  background-color: rgba(0, 123, 255, 0.6);\n  border: 2px solid rgba(0, 123, 255, 0.8);\n  box-shadow: 0 0 12px rgba(0, 123, 255, 0.4);\n  transform: scale(1.05);\n  transition: all 0.3s ease;\n}\n\n.bucket-nav-button--hidden {\n  opacity: 0.4;\n  background-color: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.1);\n  position: relative;\n}\n\n.bucket-nav-button--hidden::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 8px;\n  right: 8px;\n  height: 1px;\n  background-color: rgba(255, 255, 255, 0.6);\n  transform: translateY(-50%);\n}\n\n.bucket-nav-button--hidden:hover {\n  opacity: 0.6;\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n/* === Reorder-Modus (Shift gedrueckt) === */\n\n.bucket-nav-button--reorder {\n  cursor: grab;\n  border-style: dashed;\n  border-color: rgba(74, 158, 255, 0.4);\n}\n\n.bucket-nav-button--reorder:active {\n  cursor: grabbing;\n}\n\n.bucket-nav-button--dragging {\n  opacity: 0.4;\n  cursor: grabbing;\n}\n\n.bucket-nav-button--drag-over {\n  border-color: #4a9eff !important;\n  border-style: solid !important;\n  box-shadow: 0 0 12px rgba(74, 158, 255, 0.5);\n  transform: scale(1.05);\n}\n\n/* Additional mobile-specific styles */\n@media (max-width: 768px) {\n  .bucket-navbar {\n    /* Ensure smooth scrolling on mobile */\n    scroll-behavior: smooth;\n    -webkit-overflow-scrolling: touch;\n    width: 100vw !important;\n    max-width: 100vw !important;\n    box-sizing: border-box !important;\n    position: fixed !important;\n    top: 60px !important;\n    z-index: 99 !important;\n  }\n\n  .bucket-nav-button {\n    /* Better touch targets for mobile */\n    position: relative;\n    overflow: hidden;\n  }\n\n  .bucket-nav-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: transparent;\n    transition: background-color 0.2s ease;\n  }\n\n  .bucket-nav-button:active::before {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n\n  .bucket-nav-button__title {\n    /* Ensure text remains readable on mobile */\n    position: relative;\n    z-index: 1;\n    font-weight: 600;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n  }\n\n  /* Smooth transition for highlights on mobile */\n  .bucket-nav-button--highlight {\n    animation: mobileHighlight 0.3s ease-in-out;\n  }\n\n  @keyframes mobileHighlight {\n    0% {\n      transform: scale(1);\n      box-shadow: 0 0 0 rgba(0, 123, 255, 0);\n    }\n    50% {\n      transform: scale(1.15);\n      box-shadow: 0 0 20px rgba(0, 123, 255, 0.8);\n    }\n    100% {\n      transform: scale(1.1);\n      box-shadow: 0 0 15px rgba(0, 123, 255, 0.6);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
